import { css } from 'lit';
import color from '../../utils/get-color-token';
import token from '../../utils/get-token';
import { typography } from '../../styles';
import toRem from '../../utils/to-rem';
import skeletonStyles, { skeleton } from '../../styles/skeleton';

function tagStyles() {
	return [
		skeletonStyles(),
		css`
			:host {
				--m-tag-skeleton-width: 100px;
			}
			.tag {
				display: inline-block;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
				box-sizing: border-box;
				max-width: 200px;
				border-radius: 100px;
				line-height: ${token('line-height-1')};
				cursor: default;
			}

			.tag slot[name='leading']::slotted(*) {
				margin-inline-end: ${token('spacing-1')};
				vertical-align: middle;
			}

			.-size-small {
				${typography('chips-sm')};
				padding: ${token('spacing-1')} ${token('spacing-2')};
				block-size: ${toRem('18px')};
			}
			.-size-default {
				${typography('chips-md')};
				padding: ${token('spacing-2')} ${token('spacing-3')};
				block-size: ${token('global-height-small')};
			}
			.-size-large {
				${typography('button-lg')};
				padding: ${token('spacing-3')} ${token('spacing-4')};
				block-size: ${token('global-height-default')};
			}

			.-success {
				color: ${color('color-success-60')};
				background: ${color('color-success-20')};
			}
			.-neutral {
				color: ${color('color-text-tertiary')};
				background: ${color('color-background-tertiary')};
			}
			.-warning {
				color: ${color('color-warning-100')};
				background: ${color('color-warning-20')};
			}
			.-danger {
				color: ${color('color-danger-60')};
				background: ${color('color-danger-20')};
			}

			.-is-skeleton {
				${skeleton()};
				width: var(--m-tag-skeleton-width);
			}
		`,
	];
}

export default tagStyles;
